import type { Template } from "@/types";

export const LA_07_H5_V2: Template[] = [
    {
        id: "la-07-h5v2-01",
        name: "LA 01 - H5V2",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-07-h5_v2_01.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 96, y: 311, width: 205, height: 126, rotation: 0, imageRotation: 0 },
            { id: "2", x: 96, y: 179, width: 205, height: 125, rotation: 0, imageRotation: 0 },
            { id: "3", x: 96, y: 47, width: 205, height: 125, rotation: 0, imageRotation: 0 },
            { id: "4", x: 308, y: 47, width: 272, height: 390, rotation: 0, imageRotation: 0 },
            { id: "5", x: 761, y: 79, width: 249, height: 160, rotation: 0, imageRotation: 0 },
            { id: "6", x: 761, y: 246, width: 249, height: 159, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1017, y: 79, width: 250, height: 326, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h5v2-02",
        name: "LA 02 - H5V2",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-07-h5_v2_02.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 94, y: 40, width: 276, height: 403, rotation: 0, imageRotation: 0 },
            { id: "2", x: 378, y: 40, width: 205, height: 129, rotation: 0, imageRotation: 0 },
            { id: "3", x: 378, y: 177, width: 205, height: 266, rotation: 0, imageRotation: 0 },
            { id: "4", x: 756, y: 41, width: 516, height: 280, rotation: 0, imageRotation: 0 },
            { id: "5", x: 756, y: 328, width: 167, height: 114, rotation: 0, imageRotation: 0 },
            { id: "6", x: 931, y: 328, width: 167, height: 114, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1105, y: 328, width: 167, height: 114, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h5v2-03",
        name: "LA 03 - H5V2",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-07-h5_v2_03.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 127, y: 47, width: 416, height: 199, rotation: 0, imageRotation: 0 },
            { id: "2", x: 127, y: 253, width: 269, height: 183, rotation: 0, imageRotation: 0 },
            { id: "3", x: 404, y: 253, width: 139, height: 183, rotation: 0, imageRotation: 0 },
            { id: "4", x: 772, y: 47, width: 272, height: 390, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1051, y: 47, width: 205, height: 125, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1051, y: 179, width: 205, height: 125, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1051, y: 311, width: 205, height: 126, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h5v2-04",
        name: "LA 04 - H5V2",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-07-h5_v2_04.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 163, y: 56, width: 190, height: 119, rotation: 0, imageRotation: 0 },
            { id: "2", x: 163, y: 182, width: 190, height: 119, rotation: 0, imageRotation: 0 },
            { id: "3", x: 163, y: 309, width: 190, height: 119, rotation: 0, imageRotation: 0 },
            { id: "4", x: 361, y: 56, width: 263, height: 372, rotation: 0, imageRotation: 0 },
            { id: "5", x: 632, y: 56, width: 264, height: 372, rotation: 0, imageRotation: 0 },
            { id: "6", x: 904, y: 56, width: 286, height: 183, rotation: 0, imageRotation: 0 },
            { id: "7", x: 904, y: 246, width: 286, height: 182, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h5v2-05",
        name: "LA 05 - H5V2",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-07-h5_v2_05.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 163, y: 56, width: 190, height: 119, rotation: 0, imageRotation: 0 },
            { id: "2", x: 163, y: 182, width: 190, height: 119, rotation: 0, imageRotation: 0 },
            { id: "3", x: 163, y: 309, width: 190, height: 119, rotation: 0, imageRotation: 0 },
            { id: "4", x: 361, y: 56, width: 263, height: 372, rotation: 0, imageRotation: 0 },
            { id: "5", x: 632, y: 56, width: 286, height: 183, rotation: 0, imageRotation: 0 },
            { id: "6", x: 632, y: 246, width: 286, height: 182, rotation: 0, imageRotation: 0 },
            { id: "7", x: 926, y: 56, width: 264, height: 372, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h5v2-06",
        name: "LA 06 - H5V2",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-07-h5_v2_06.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 29, y: 56, width: 575, height: 372, rotation: 0, imageRotation: 0 },
            { id: "2", x: 611, y: 56, width: 132, height: 183, rotation: 0, imageRotation: 0 },
            { id: "3", x: 750, y: 56, width: 284, height: 183, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1042, y: 56, width: 284, height: 183, rotation: 0, imageRotation: 0 },
            { id: "5", x: 611, y: 246, width: 284, height: 182, rotation: 0, imageRotation: 0 },
            { id: "6", x: 902, y: 246, width: 284, height: 182, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1194, y: 246, width: 132, height: 182, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h5v2-07",
        name: "LA 07 - H5V2",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-07-h5_v2_07.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 28, y: 56, width: 575, height: 372, rotation: 0, imageRotation: 0 },
            { id: "2", x: 611, y: 56, width: 132, height: 183, rotation: 0, imageRotation: 0 },
            { id: "3", x: 750, y: 56, width: 284, height: 183, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1042, y: 56, width: 284, height: 183, rotation: 0, imageRotation: 0 },
            { id: "5", x: 611, y: 246, width: 132, height: 182, rotation: 0, imageRotation: 0 },
            { id: "6", x: 750, y: 246, width: 284, height: 182, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1042, y: 246, width: 284, height: 182, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h5v2-08",
        name: "LA 08 - H5V2",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-07-h5_v2_08.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 28, y: 56, width: 575, height: 372, rotation: 0, imageRotation: 0 },
            { id: "2", x: 611, y: 56, width: 284, height: 183, rotation: 0, imageRotation: 0 },
            { id: "3", x: 902, y: 56, width: 284, height: 183, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1194, y: 56, width: 132, height: 183, rotation: 0, imageRotation: 0 },
            { id: "5", x: 611, y: 246, width: 284, height: 182, rotation: 0, imageRotation: 0 },
            { id: "6", x: 902, y: 246, width: 284, height: 182, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1194, y: 246, width: 132, height: 182, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h5v2-09",
        name: "LA 09 - H5V2",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-07-h5_v2_09.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 84, y: 62, width: 313, height: 204, rotation: 0, imageRotation: 0 },
            { id: "2", x: 404, y: 62, width: 312, height: 204, rotation: 0, imageRotation: 0 },
            { id: "3", x: 84, y: 273, width: 206, height: 149, rotation: 0, imageRotation: 0 },
            { id: "4", x: 298, y: 273, width: 206, height: 149, rotation: 0, imageRotation: 0 },
            { id: "5", x: 511, y: 273, width: 206, height: 149, rotation: 0, imageRotation: 0 },
            { id: "6", x: 724, y: 62, width: 270, height: 360, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1001, y: 62, width: 269, height: 360, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h5v2-10",
        name: "LA 10 - H5V2",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-07-h5_v2_10.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 82, y: 61, width: 269, height: 360, rotation: 0, imageRotation: 0 },
            { id: "2", x: 358, y: 61, width: 270, height: 360, rotation: 0, imageRotation: 0 },
            { id: "3", x: 635, y: 217, width: 312, height: 204, rotation: 0, imageRotation: 0 },
            { id: "4", x: 849, y: 61, width: 206, height: 149, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1062, y: 61, width: 206, height: 149, rotation: 0, imageRotation: 0 },
            { id: "6", x: 635, y: 61, width: 206, height: 149, rotation: 0, imageRotation: 0 },
            { id: "7", x: 955, y: 217, width: 313, height: 204, rotation: 0, imageRotation: 0 }
        ],
    }
];